module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "not-found"
  }, [_c('h1', [_vm._v("There is no such project!")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Back to home")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a86191f"}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/NotFound.vue
// module id = 99
// module chunks = 0